export const TOTAL_COSTS = {
  prefix: "$",
  value: 4257.65,
  suffix: "",
  change: 0,
  changeSuffix: "",
  decimals: 0,
};
